import { useEffect, useSyncExternalStore } from 'react';
import { getSyncActivity, subscribeSyncActivity, hydrateLastSuccess, type SyncActivity } from '@/db/sync-activity';

/**
 * Reactive view of the data layer's sync activity (pull/push in flight, last
 * outcome, last successful sync time). Backed by src/db/sync-activity.ts.
 */
export function useSyncActivity(): SyncActivity {
  useEffect(() => {
    void hydrateLastSuccess();
  }, []);

  return useSyncExternalStore(subscribeSyncActivity, getSyncActivity, getSyncActivity);
}
